import {gql} from "@apollo/client";

export const QUERY_GET_STATS_DATA = gql`
query generalInfo($nLastDays: Int!) {
  generalInfo(nLastDays: $nLastDays) {
        nLastDays
        measureUnit {
            volumeUnit
        }
        entities {
            sites
            waterSystems
        }
        waterConsumption {
            current
            increaseDate
            increaseValue
            lastMonthDate
            lastMonthValue
        }
        leaksVolume {
            current
            increaseValue
            lastMonthDate
            lastMonthValue
        }
        alertingSystems {
            current
            increaseValue
            lastMonthDate
            lastMonthValue
        }
        leakAlerts {
            current {          
                count
                severity {
                    label
                    value
                }
            }
            lastMonth {
                date
                count
                severity {
                    label
                    value
                }
            }
        }
        cost {
            current
            currencyUnit
            carbonEmission
            currentDate
            increaseDate
            increaseValue
        }
    }
}
`

export const QUERY_GET_USER_PREFERENCE = gql`
{
    userPreference {
        currencyUnit
        waterPrice
        volumeUnit
        flowrateUnit
        volumeUnit
        costVolumeUnit
    }
}
`

export const QUERY_GET_WATER_CONSUMPTION = gql`
query waterConsumptionHistogram(
  $resolution: TimeResolution!
  $from: LocalDate!
  $to: LocalDate!
) {
  waterConsumptionHistogram(
    resolution: $resolution
    from: $from
    to: $to
  ) {
    measureUnit {
        volumeUnit
    }
    resolution
    data {
      date
      from
      to
      value
    }
  }
}
`

export const QUERY_GET_NUMBER_OF_LEAK_ALERTS = gql`
query leakAlertsHistogram(
  $resolution: TimeResolution!
  $from: LocalDate!
  $to: LocalDate!
) {
  leakAlertsHistogram(
    resolution: $resolution
    from: $from
    to: $to
  ) {
        resolution
        data {
            date
            from
            to
            severity {
                label
                value
            }
        }
  }
}
`

export const QUERY_GET_ALERTS_BY_FLOW_TYPE = gql`
query leakAlertChart($from: LocalDate!, $to: LocalDate!) {
  leakAlertChart(dateRange: { from: $from, to: $to }) {
    severity {
      label
      value
    }
  }
}
`

export const QUERY_GET_CONSUMPTION_AND_POTENTIAL_WASTE = gql`
query waterConsumptionAndLeakWasteEntityChart(
  $entityType: EntityRequestType!
  $from: LocalDate!
  $to: LocalDate!
  $systemTypeGroups:[SystemTypeGroup]!
) {
  waterConsumptionAndLeakWasteEntityChart(
    entityType: $entityType
    dateRange: { from: $from, to: $to }
    systemTypeGroups: $systemTypeGroups
  ) {
    measureUnit {
        volumeUnit
    }
    entityType
    entities {
      id
      name
      type
      data {
        waterConsumption
        potentialWaste
      }
    }
  }
}`

export const QUERY_GET_SITE_WATER_CONSUMPTION_DATA_TABLE = gql`
query waterConsumptionAndLeakWasteDatatable(
  $from: LocalDate!
  $to: LocalDate!
  $entityType: EntityRequestType!
) {
  waterConsumptionAndLeakWasteDatatable(
    dateRange: { from: $from, to: $to }
    entityType: $entityType
  ) {
    measureUnit {
        volumeUnit
    }
    entityType
    data {
      id
      name
      waterConsumption
      leaksVolume
      potentialWaste
      totalAlerts
      leaksRatio
    }
  }
}
`

export const QUERY_GET_WATER_SYSTEM_CONSUMPTION_SITE_DATA_TABLE = gql`
query waterConsumptionAndLeakWasteDatatable(
  $from: LocalDate!
  $to: LocalDate!
  $entityType: EntityRequestType!
) {
  waterConsumptionAndLeakWasteDatatable(
    dateRange: { from: $from, to: $to }
    entityType: $entityType
  ) {
    measureUnit {
        volumeUnit
    }
    entityType
    data {
      id
      name
      siteName
      waterConsumption
      leaksVolume
      potentialWaste
      totalAlerts
      leaksRatio
    }
  }
}
`

export const QUERY_GET_NUMBER_OF_LEAK_ALERTS_PIE = gql`
query leakAlertEntityChart(
  $from: LocalDate!
  $to: LocalDate!
  $entityType: EntityRequestType!
) {
    leakAlertEntityChart(dateRange: { from: $from, to: $to }, entityType: $entityType) {
        entityType
        entities {
            id
            name
            severity {
                label
                value
            }
        }
    }
}
`

export const QUERY_GET_LEAK_VOLUME_OVER_TIME = gql`
query leakVolumeEntityHistogram (
  $from: LocalDate!
  $to: LocalDate!
  $resolution: TimeResolution!
  $entityType: EntityRequestType!
) {
    leakVolumeEntityHistogram(
        entityType: $entityType
        resolution: $resolution
        from: $from
        to: $to
    ) {
        measureUnit {
            volumeUnit
        }
        entityType
        resolution
        entities {
            id
            name
            data {
                date
                from
                to
                volume
            }
        }
    }
}`

export const QUERY_GET_LEAK_VOLUME_AND_CONSUMPTION = gql`
query leakVolumeAndWaterConsumptionEntityChart(
  $entityType: EntityRequestType!
  $from: LocalDate!
  $to: LocalDate!
  $systemTypeGroups:[SystemTypeGroup]!
) {
  leakVolumeAndWaterConsumptionEntityChart(
    entityType: $entityType
    dateRange: { from: $from, to: $to }
    systemTypeGroups: $systemTypeGroups
  ) {
    measureUnit {
        volumeUnit
    }
    entityType
    entities {
      id
      name
      type
      data {
        waterConsumption
        severity {
          label
          value
        }
      }
    }
  }
}`

export const QUERY_GET_WATER_CONSUMPTION_AND_ALERTS = gql`
query waterConsumptionAndLeakAlertsHistogram (
  $from: LocalDate!
  $to: LocalDate!
  $resolution: TimeResolution!
  $entityType: EntityRequestType!
) {
    waterConsumptionAndLeakAlertsHistogram(
        entityType: $entityType
        resolution: $resolution
        from: $from
        to: $to
    ) {
        measureUnit {
            volumeUnit
        }
        entityType
        resolution
        entities {
            id
            name
            data {
                date
                from
                to
                leakAlerts
                waterConsumption
            }
        }
    }
}`

export const SET_COST_PREFERENCES = gql`
mutation saveUserPreferences($userPreferences: InputUserPreferencesApiDto!){
    saveUserPreferences(userPreferences: $userPreferences) {
        costVolumeUnit
        waterPrice
        currencyUnit
        flowrateUnit
        volumeUnit
    }
}
    `